import * as React from 'react'
import styled from 'styled-components'
import Logo from './Logo'
import SignInButton from '../global/SignInButton'

import Profile from './Profile'
import NotificationButton from './NotificationButton'

import useAuth from '../../hooks/auth'
import SearchBar from './SearchBar'
import { useMediaQuery } from '@material-ui/core'
import Metrics from './Metrics'
import Trending from './Trending'

const OuterDiv = styled.div<{ sticky: boolean }>`
  height: 75px;
  background-color: rgb(16, 16, 16);
  backdrop-filter: blur(10px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: ${(props) => (props.sticky ? `fixed` : `relative`)};
  top: 0;
  width: 100%;
  z-index: 1002;

  @media (min-width: 43em) {
    background-color: rgb(16, 16, 16, 0.25);
    height: 75px;
  }
`

export const InnerDiv = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 1800px;
  margin: auto;
`

const Spacer = styled.div`
  flex-grow: 1;
`

const FullHeaderDiv = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  width: 100%;
  top: 0;
`

const Header = (): JSX.Element => {
  const { isAuthenticated } = useAuth()
  const isMobile = useMediaQuery('(max-width: 62em)')
  const [sticky, setSticky] = React.useState(false)

  React.useEffect(() => {
    window.addEventListener('scroll', isSticky)
    return () => {
      window.removeEventListener('scroll', isSticky)
    }
  }, [])

  const isSticky = () => {
    const scrollTop = window.scrollY
    const sticky = scrollTop >= 25 ? true : false
    setSticky(sticky)
  }

  return (
    <FullHeaderDiv>
      <Metrics />
      <OuterDiv sticky={sticky}>
        <InnerDiv>
          <Logo />
          {isMobile && <Spacer />}
          {isMobile && !isAuthenticated && <Trending />}
          <SearchBar />
          {!isMobile && <Trending />}
          {/* {!isMobile && <Studio />} */}
          {isAuthenticated && <NotificationButton />}
          {isAuthenticated ? <Profile /> : <SignInButton />}
        </InnerDiv>
      </OuterDiv>
    </FullHeaderDiv>
  )
}

export default Header
